import React from 'react';
import DOMPurify from 'dompurify';
const Linkify = ({ children }) => {
    const linkifyText = (text) => {
        const urlPattern = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\-\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\-\+.~#?&//=]*)/gi;
        return text.replace(urlPattern, (url) => {
            const href = url.startsWith('http') ? url : `https://${url}`;
            return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };
    const sanitizedHtml = DOMPurify.sanitize(linkifyText(children));
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: sanitizedHtml } });
};
export default Linkify;
//# sourceMappingURL=Linkify.js.map